module.exports = __webpack_public_path__ + "3fd52293d9cf95ad62c060de579b61f2.png";